import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import OurStoryComponent from "salad/OurStoryComponent.js";
import MobileHeaderOnly from "components/headers/light.js";
import GrainFooter from "salad/GrainFooter";

export default () => (
    <div style={{ backgroundColor: "#FFFBDC" }}>
        <MobileHeaderOnly />
        <AnimationRevealPage>
            <OurStoryComponent />
            <GrainFooter/>
        </AnimationRevealPage>
    </div>
);
